// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.go-table {
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 0.0925rem 0.165rem rgba(0, 0, 0, 0.19);
  border: none;
}
.go-table .go-thead {
  background: #52796F;
  border-bottom: 1px solid #c9c9c9;
  color: white;
}
.go-table tr {
  border-bottom: 1px solid #c9c9c9;
}
.go-table tr:last-child {
  border-bottom: none !important;
}

.table-responsive {
  max-height: 600px;
  padding: 1rem;
  border: none;
}

.pagination {
  margin: 15px auto;
  list-style: none;
  outline: none;
  display: inline-flex;
  padding-left: 0;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.pagination > .active > a {
  background-color: #47ccde;
  /* border-color: #47ccde ; */
  color: #fff;
}

.pagination > li > a {
  padding: 0.375rem 0.75rem;
  margin: 2px;
  position: relative;
  display: block;
  color: #1890ff;
  font-weight: 600;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #dee2e6;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.pagination > .active > a, .pagination > .active > span, .pagination > .active > a:hover, .pagination > .active > span:hover, .pagination > .active > a:focus, .pagination > .active > span:focus {
  z-index: 3;
  color: #fff;
  background-color: #1890ff;
  border-color: #1890ff;
}

.pagination > li > a, .pagination > li > span {
  color: #1890ff;
}

.pagination > li:first-child > a, .pagination > li:first-child > span, .pagination > li:last-child > a, .pagination > li:last-child > span {
  border-radius: unset;
}

.pagi {
  align-content: center;
}

.label-text {
  display: flex;
  text-align: center;
  flex-direction: column;
  font-size: 1rem;
  font-weight: 600;
}

.input-text {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
}

.ant-divider-horizontal {
  display: flex;
  clear: both;
  width: 100%;
  min-width: 100%;
  margin: 15px 0;
}

.desc {
  text-align: left;
  max-width: 100px;
}

.desc2 {
  text-align: left;
  max-width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Annotation/Local.scss","webpack://./src/scss/globals.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAGA;EAEE,gBAAA;EACA,mBCNc;EDOd,oDAAA;EACA,YAAA;AAHF;AAQE;EACE,mBEVQ;EFWR,gCAAA;EACA,YAAA;AANJ;AAaE;EACE,gCAAA;AAXJ;AAaI;EACE,8BAAA;AAXN;;AAgBA;EACA,iBAAA;EAEE,aAAA;EACA,YAAA;AAdF;;AAkBA;EACI,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AAfJ;;AAkBE;EACE,yBAAA;EACA,4BAAA;EACA,WAAA;AAfJ;;AAiBE;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qIAAA;AAdJ;;AAgBE;EACE,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AAbJ;;AAgBE;EACE,cAAA;AAbJ;;AAeE;EACE,oBAAA;AAZJ;;AAcE;EACE,qBAAA;AAXJ;;AAcE;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAXJ;;AAcA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAXJ;;AAcA;EACE,aAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAXF;;AAeA;EACI,gBAAA;EAEA,gBAAA;AAbJ;;AAgBA;EACI,gBAAA;EAEA,gBAAA;AAdJ","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/globals';\n\n.go-table {\n\n  overflow: hidden;\n  border-radius: $border-radius;\n  box-shadow: 0 .0925rem .165rem rgba(0, 0, 0, 0.19);\n  border: none;\n\n  \n\n\n  .go-thead {\n    background: $palette-2;\n    border-bottom: 1px solid $color-light-grey;\n    color: white;\n    \n\n  \n  }\n\n\n  tr {\n    border-bottom: 1px solid $color-light-grey;\n\n    &:last-child {\n      border-bottom: none!important;\n    }\n  }\n}\n\n.table-responsive {\nmax-height: 600px;\n\n  padding: 1rem;\n  border: none;\n}\n\n\n.pagination {\n    margin: 15px auto;\n    list-style: none;\n    outline: none;\n    display: inline-flex;\n    padding-left: 0;\n    margin-top: .5rem;\n    margin-bottom: .5rem; \n\n  }\n  .pagination > .active > a{\n    background-color: #47ccde ;\n    /* border-color: #47ccde ; */\n    color: #fff;\n  }\n  .pagination > li > a{\n    padding: .375rem .75rem;\n    margin: 2px;\n    position: relative;\n    display: block;\n    color: #1890ff;\n    font-weight: 600;\n    text-decoration: none;\n    background-color: #fff;\n    border: 1px solid #dee2e6;\n    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n  }\n  .pagination > .active > a, .pagination > .active > span, .pagination > .active > a:hover, .pagination > .active > span:hover, .pagination > .active > a:focus, .pagination > .active > span:focus{\n    z-index: 3;\n    color: #fff;\n    background-color: #1890ff;\n    border-color: #1890ff;\n   \n  }\n  .pagination > li > a, .pagination > li > span{\n    color: #1890ff\n  }\n  .pagination > li:first-child > a, .pagination > li:first-child > span, .pagination > li:last-child > a, .pagination > li:last-child > span{\n    border-radius: unset\n  }\n  .pagi {\n    align-content: center;\n  }\n\n  .label-text {\n    display: flex;\n    text-align: center;\n    flex-direction: column;\n    font-size: 1rem;\n    font-weight: 600;\n}\n\n.input-text {\n    display: flex;\n    flex-direction: column;\n    border-radius: 10px;\n}\n\n.ant-divider-horizontal {\n  display: flex;\n  clear: both;\n  width: 100%;\n  min-width: 100%;\n  margin: 15px 0;\n}\n\n\n.desc{\n    text-align: left ;\n    \n    max-width: 100px;\n}\n\n.desc2{\n    text-align: left ;\n    \n    max-width: 200px;\n}\n\n\n\n\n","$border-radius: 10px;\n$big-radius: 16px;\n$radius-btn: 10px;\n$nav-radius: 12px;\n\n$fw-light: 300;\n$fw-medium: 400;\n$fw-heavy: 500;\n","$black: #011627;\n$white: #FDFFFC;\n$palette-1: #217ed5;\n// $palette-2: #074ba5;\n$palette-2: #52796F;\n$palette-3: #FF9F1C;\n$palette-4:rgba(239, 48, 48, 0.822);\n$palette-5: #748b80;\n// 5fa15a\n// eab271\n// 1d2d44d0\n$nav-outline: #eff;\n$nav-outline-hvr: rgba(#217ed5,.4);\n\n$text-ghost:rgb(0, 0, 0);\n$text-light: #717171;\n$text-main: #393939;\n$text-hard: #212121;\n\n$color-light-grey: #c9c9c9;\n\n$palette-1-v-light: #abeef0;\n\n$palette-1-bg: #e2fcfc;\n$palette-2-bg: #ffe4eb;\n\n$palette-1-light: #1890ff;\n$palette-2-light: #ffe9ee;\n\n$palette-1-dark: #1472ca;\n$palette-2-dark: #ab1236;\n$palette-3-dark: #bb781c;\n$palette-4-dark:rgba(243, 16, 16, 0.87);\n\n$chip-bg: #def5ff;\n$chip-font: #036778;\n\n$palette-1-pastel: #a9fafc;\n\n$nav-back : #96c4a0;\n// 9ecf7d\n// f08585\n// 7dce82\n// rgb(152, 171, 196)"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
